import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useLocaleStore } from '@/store/locale'
import { LANGUAGES } from '@/constants'

import { cn } from '@/lib/utils'

type LanguageListProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    onClose: () => void
    className: string
    itemClassName: string
  }>

const LanguageList: React.FC<LanguageListProps> = ({
  className,
  itemClassName,
  ...props
}) => {
  const [currentLocale, currentTranslations] = useLocaleStore((state) => [
    state.currentLocale,
    state.currentTranslations
  ])

  return (
    <div className={cn('flex items-center gap-[0.8rem]', className)} {...props}>
      {LANGUAGES.filter((lang: string) => lang !== currentLocale).map(
        (lang: string, index: number) => (
          <div key={index.toString()}>
            <a
              href={
                currentTranslations?.find((t: { locale: string }) =>
                  t.locale.includes(lang)
                )?.href || `/${lang}`
              }
              className={cn('-m-[0.5rem] inline-flex p-[0.5rem]')}
            >
              <Typography
                variant="regular"
                className={cn(
                  'uppercase',
                  itemClassName ?? 'dark:text-text-heading-invert-light'
                )}
              >
                {lang}
              </Typography>
            </a>
          </div>
        )
      )}
    </div>
  )
}

export default LanguageList
